import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bcbeb498"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "cover",
  src: "/img/EPCover.png"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"stream-on\" data-v-bcbeb498><a href=\"https://open.spotify.com/intl-de/album/1OOj7hVs0j815lKRYyUga4?si=XjJ0g312TwilNqjUww79KQ\" target=\"_blank\" data-v-bcbeb498><img src=\"/img/spotify.png\" data-v-bcbeb498></a><a href=\"https://music.apple.com/de/album/arise-ep-ep/1847383463\" target=\"_blank\" data-v-bcbeb498><img src=\"/img/apple_music.svg\" data-v-bcbeb498></a></div>", 1)
const _hoisted_4 = {
  key: 0,
  class: "mini-cover"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/img/EPCover.png" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  viewBox: "0 0 48 48",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  fill: "#000000"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\" data-v-bcbeb498></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-bcbeb498></g><g id=\"SVGRepo_iconCarrier\" data-v-bcbeb498><title data-v-bcbeb498>ic_fluent_play_48_filled</title> <desc data-v-bcbeb498>Created with Sketch.</desc> <g id=\"🔍-Product-Icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" data-v-bcbeb498><g id=\"ic_fluent_play_48_filled\" fill=\"#CCCCCC\" fill-rule=\"nonzero\" data-v-bcbeb498><path d=\"M13.7501344,8.41212026 L38.1671892,21.1169293 C39.7594652,21.9454306 40.3786269,23.9078584 39.5501255,25.5001344 C39.2420737,26.0921715 38.7592263,26.5750189 38.1671892,26.8830707 L13.7501344,39.5878797 C12.1578584,40.4163811 10.1954306,39.7972194 9.36692926,38.2049434 C9.12586301,37.7416442 9,37.2270724 9,36.704809 L9,11.295191 C9,9.50026556 10.4550746,8.045191 12.25,8.045191 C12.6976544,8.045191 13.1396577,8.13766178 13.5485655,8.31589049 L13.7501344,8.41212026 Z\" id=\"🎨-Color\" data-v-bcbeb498></path></g></g></g>", 3)
const _hoisted_11 = [
  _hoisted_8
]
const _hoisted_12 = {
  key: 1,
  viewBox: "0 0 48 48",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  fill: "#000000"
}
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\" data-v-bcbeb498></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-bcbeb498></g><g id=\"SVGRepo_iconCarrier\" data-v-bcbeb498><title data-v-bcbeb498>ic_fluent_pause_48_filled</title> <desc data-v-bcbeb498>Created with Sketch.</desc> <g id=\"🔍-Product-Icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" data-v-bcbeb498><g id=\"ic_fluent_pause_48_filled\" fill=\"#CCCCCC\" fill-rule=\"nonzero\" data-v-bcbeb498><path d=\"M17.75,7 C19.5449254,7 21,8.45507456 21,10.25 L21,37.75 C21,39.5449254 19.5449254,41 17.75,41 L12.25,41 C10.4550746,41 9,39.5449254 9,37.75 L9,10.25 C9,8.45507456 10.4550746,7 12.25,7 L17.75,7 Z M35.75,7 C37.5449254,7 39,8.45507456 39,10.25 L39,37.75 C39,39.5449254 37.5449254,41 35.75,41 L30.25,41 C28.4550746,41 27,39.5449254 27,37.75 L27,10.25 C27,8.45507456 28.4550746,7 30.25,7 L35.75,7 Z\" id=\"🎨-Color\" data-v-bcbeb498></path></g></g></g>", 3)
const _hoisted_16 = [
  _hoisted_13
]
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<svg viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"#000000\" data-v-bcbeb498><g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\" data-v-bcbeb498></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-bcbeb498></g><g id=\"SVGRepo_iconCarrier\" data-v-bcbeb498><title data-v-bcbeb498>ic_fluent_arrow_previous_24_filled</title> <desc data-v-bcbeb498>Created with Sketch.</desc> <g id=\"🔍-Product-Icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" data-v-bcbeb498><g id=\"ic_fluent_arrow_previous_24_filled\" fill=\"#CCCCCC\" fill-rule=\"nonzero\" data-v-bcbeb498><path d=\"M6,3 C5.48716416,3 5.06449284,3.38604019 5.00672773,3.88337887 L5,4 L5,20 C5,20.5522847 5.44771525,21 6,21 C6.51283584,21 6.93550716,20.6139598 6.99327227,20.1166211 L7,20 L7,4 C7,3.44771525 6.55228475,3 6,3 Z M18.7071068,3.29289322 C18.3466228,2.93240926 17.7793918,2.90467972 17.3871006,3.20970461 L17.2928932,3.29289322 L9.29289322,11.2928932 C8.93240926,11.6533772 8.90467972,12.2206082 9.20970461,12.6128994 L9.29289322,12.7071068 L17.2928932,20.7071068 C17.6834175,21.0976311 18.3165825,21.0976311 18.7071068,20.7071068 C19.0675907,20.3466228 19.0953203,19.7793918 18.7902954,19.3871006 L18.7071068,19.2928932 L11.4142136,12 L18.7071068,4.70710678 C19.0976311,4.31658249 19.0976311,3.68341751 18.7071068,3.29289322 Z\" id=\"🎨-Color\" data-v-bcbeb498></path></g></g></g></svg>", 1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<svg viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"#000000\" data-v-bcbeb498><g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\" data-v-bcbeb498></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-bcbeb498></g><g id=\"SVGRepo_iconCarrier\" data-v-bcbeb498><title data-v-bcbeb498>ic_fluent_arrow_next_24_filled</title> <desc data-v-bcbeb498>Created with Sketch.</desc> <g id=\"🔍-Product-Icons\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" data-v-bcbeb498><g id=\"ic_fluent_arrow_next_24_filled\" fill=\"#CCCCCC\" fill-rule=\"nonzero\" data-v-bcbeb498><path d=\"M18,3 C18.5128358,3 18.9355072,3.38604019 18.9932723,3.88337887 L19,4 L19,20 C19,20.5522847 18.5522847,21 18,21 C17.4871642,21 17.0644928,20.6139598 17.0067277,20.1166211 L17,20 L17,4 C17,3.44771525 17.4477153,3 18,3 Z M5.29289322,3.29289322 C5.65337718,2.93240926 6.22060824,2.90467972 6.61289944,3.20970461 L6.70710678,3.29289322 L14.7071068,11.2928932 C15.0675907,11.6533772 15.0953203,12.2206082 14.7902954,12.6128994 L14.7071068,12.7071068 L6.70710678,20.7071068 C6.31658249,21.0976311 5.68341751,21.0976311 5.29289322,20.7071068 C4.93240926,20.3466228 4.90467972,19.7793918 5.20970461,19.3871006 L5.29289322,19.2928932 L12.5857864,12 L5.29289322,4.70710678 C4.90236893,4.31658249 4.90236893,3.68341751 5.29289322,3.29289322 Z\" id=\"🎨-Color\" data-v-bcbeb498></path></g></g></g></svg>", 1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "progress-holder" }
const _hoisted_22 = {
  key: 0,
  class: "current-title"
}
const _hoisted_23 = {
  key: 1,
  class: "playlist"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "icon" }
const _hoisted_26 = { class: "title" }
const _hoisted_27 = { class: "lenth" }

import { computed, Ref, ref } from 'vue'
import EqIcon from './eq-icon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'cover-player',
  props: {
  isMini: Boolean
},
  setup(__props) {

const props = __props

const songs = [
  { title: 'Arise', length: '4.42', file: '01 Arise.mp3' },
  { title: 'Breaking Bad', length: '4:55', file: '02 Breaking Bad.mp3' },
  { title: 'Haunted', length: '4:43', file: '03 Haunted.mp3' },
  { title: 'The One', length: '5.24', file: '04 The One.mp3' }
]

const player = ref() as Ref<HTMLAudioElement>
const isPLaying = ref(false)
const currentTrack = ref(0)

const trackDuration = ref(0)
const currentTime = ref(0)

const currentTitle = computed(() => songs[currentTrack.value].title)
const currentDuration = computed(() => songs[currentTrack.value].length)
const currentSrc = computed(() => '/audio/' + songs[currentTrack.value].file)
const currentElapsed = computed(() => {
  let perc = 0
  if (trackDuration.value > 0) {
    perc = currentTime.value / trackDuration.value * 100
  }
  return `${perc}%`
})

function canPlay () {
  if (isPLaying.value) {
    player.value.play()
  }
}

function ended () {
  if (currentTrack.value < songs.length - 1) {
    next()
  } else {
    isPLaying.value = false
  }
}

function progress () {
  currentTime.value = player.value.currentTime
}

function durationChange () {
  trackDuration.value = player.value.duration
  currentTime.value = player.value.currentTime
  if (isPLaying.value) player.value.play()
}

function togglePlay () {
  if (isPLaying.value) {
    player.value.pause()
  } else {
    player.value.play()
  }
  isPLaying.value = !isPLaying.value
}

function playTrack (i: number) {
  currentTrack.value = i
  isPLaying.value = true
  player.value.play()
}

function next () {
  currentTrack.value = currentTrack.value >= songs.length - 1 ? 0 : currentTrack.value + 1
}

function prev () {
  currentTrack.value = currentTrack.value > 0 ? currentTrack.value - 1 : songs.length - 1
}

function setSongPosition (e:Event) {
  const evt = e as PointerEvent
  const targ = e.target as HTMLDivElement
  const perc = evt.offsetX / targ.clientWidth
  const newPos = player.value.duration * perc
  player.value.currentTime = newPos
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["holder", {mini: __props.isMini}])
  }, [
    _createElementVNode("audio", {
      ref_key: "player",
      ref: player,
      src: currentSrc.value,
      onDurationchange: durationChange,
      onTimeupdate: progress,
      onCanplaythrough: canPlay,
      onEnded: ended
    }, null, 40, _hoisted_1),
    (!__props.isMini)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("", true),
    _hoisted_3,
    _createElementVNode("div", {
      class: _normalizeClass(["controls", {bg:!__props.isMini}])
    }, [
      (__props.isMini)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "play",
        onClick: togglePlay
      }, [
        (!isPLaying.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_11))
          : _createCommentVNode("", true),
        (isPLaying.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_16))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        class: "prev",
        onClick: prev
      }, _hoisted_18),
      _createElementVNode("button", {
        class: "next",
        onClick: next
      }, _hoisted_20),
      _createElementVNode("div", _hoisted_21, [
        (__props.isMini)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(currentTrack.value + 1) + ". " + _toDisplayString(currentTitle.value) + " (" + _toDisplayString(currentDuration.value) + ")", 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "progress",
          onClick: setSongPosition
        }, [
          _createElementVNode("div", {
            class: "elapsed",
            style: _normalizeStyle({width: currentElapsed.value})
          }, null, 4)
        ])
      ])
    ], 2),
    (!__props.isMini)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("ul", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(songs, (track, i) => {
              return _createElementVNode("li", {
                key: i,
                class: _normalizeClass(["bg", {active: currentTrack.value == i}]),
                onClick: ($event: any) => (playTrack(i))
              }, [
                _createElementVNode("span", _hoisted_25, [
                  (isPLaying.value && currentTrack.value == i)
                    ? (_openBlock(), _createBlock(EqIcon, { key: 0 }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_26, _toDisplayString(i + 1) + ". " + _toDisplayString(track.title), 1),
                _createElementVNode("span", _hoisted_27, _toDisplayString(track.length), 1)
              ], 10, _hoisted_24)
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})